import { render, staticRenderFns } from "./FormSubmitButton.vue?vue&type=template&id=be35563c&scoped=true&"
import script from "./FormSubmitButton.vue?vue&type=script&lang=js&"
export * from "./FormSubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./FormSubmitButton.vue?vue&type=style&index=0&id=be35563c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be35563c",
  null
  
)

export default component.exports